import { Link, useNavigate, useParams } from '@tanstack/react-router';
import { toast } from 'sonner';
import { LoanForm } from '@/features/loans/LoanForm';
import { useLoan, useUpdateLoan } from '@/features/loans/queries';
import { apiErrorMessage } from '@/lib/api';

export function EditLoanPage() {
  const { propertyId, loanId } = useParams({ strict: false }) as { propertyId: string; loanId: string };
  const propertyIdNum = Number(propertyId);
  const loanIdNum = Number(loanId);
  const navigate = useNavigate();

  const loan = useLoan(propertyIdNum, loanIdNum);
  const updateLoan = useUpdateLoan(propertyIdNum, loanIdNum);

  if (loan.isPending) return <p className="text-muted-foreground">Chargement…</p>;
  if (loan.isError || !loan.data) return <p className="text-destructive">Prêt introuvable.</p>;

  return (
    <div className="flex flex-col gap-6">
      <Link
        to="/biens/$propertyId/prets/$loanId"
        params={{ propertyId, loanId }}
        className="text-sm text-muted-foreground hover:underline"
      >
        ← Retour au prêt
      </Link>
      <h1 className="text-2xl font-semibold">Modifier {loan.data.lender}</h1>
      <LoanForm
        loan={loan.data}
        locked={loan.data.hasSchedule}
        isPending={updateLoan.isPending}
        onSubmit={(input) =>
          updateLoan.mutate(input, {
            onSuccess: () => {
              toast.success('Prêt mis à jour');
              void navigate({ to: '/biens/$propertyId/prets/$loanId', params: { propertyId, loanId } });
            },
            onError: (error) => {
              toast.error(apiErrorMessage(error, 'Échec de la mise à jour'));
            },
          })
        }
      />
    </div>
  );
}
